import { useEffect, useRef } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { apiRequest } from '@/lib/queryClient';

export function TimezoneAutoDetect() {
  const { user, refreshUser } = useAuth();
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current || !user || user.timezone) return;
    firedRef.current = true;

    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!tz) return;

    apiRequest('PUT', '/api/users/me/profile', { timezone: tz })
      .then(res => {
        if (res.ok) refreshUser();
      })
      .catch(() => {});
  }, [user, refreshUser]);

  return null;
}
